import { computed, onBeforeUnmount, ref } from 'vue';

export const useLazyInterval = (fn: () => any, intervalMs: number) => {
    const timer = ref<any>(null);

    const start = () => {
        if (!timer.value) {
            timer.value = setInterval(fn, intervalMs);
        }
    };

    const stop = () => {
        if (timer.value) {
            clearInterval(timer.value);
            timer.value = null;
        }
    };

    onBeforeUnmount(stop);

    const isRunning = computed(() => Boolean(timer.value));

    return {
        isRunning,
        start,
        stop,
    };
};
